<template>
  <Dialog ref="p">
    <div class="dialog-content">
      <div class="reward-num"><span>+</span><span>{{detail.reward}}</span><span>元</span></div>
      <div class="desc" v-text="'领取《' + detail.title + '》红包'"></div>
      <div class="btn-middle" @click="submit()">继续赚钱</div>
    </div>
  </Dialog>
</template>
<style lang='scss' scoped>
  .dialog-content {
    width: 295px;
    height: 204px;
    padding: 30px 26px;
    text-align: center;

    .title {
      font-size: 18px;
      color: #3A3A3A;
      margin-bottom: 10px;

      @include semibold();
    }

    .reward-num {
      font-size: 36px;
      color: #F75946;

      span:first-child {
        font-size: 20px;
        color: #F75946;
        margin-right: 2px;

        @include roboto();
      }

      span:nth-child(2) {
        font-size: 36px;
        color: #F75946;
        margin-right: 2px;

        @include roboto();
      }

      span:nth-child(3) {
        font-size: 13px;
        color: #F75946;

        @include semibold();
      }
    }

    .desc {
      font-size: 13px;
      color: #3A3A3A;
      margin-bottom: 30px;

      @include regular();
    }

    .btn-middle {
      margin: 0 auto;
    }
  }
</style>
<script>
  import { mapState, mapMutations } from 'vuex'
  import Dialog from 'components/Dialog'
  export default {
    components: {
      Dialog
    },
    computed: {
      ...mapState({
        detail: state => state.dashboard.taskDetail
      })
    },
    methods: {
      ...mapMutations(['dashboardState']),
      show () {
        this.$refs.p.show()
      },
      hide () {
        this.$refs.p.hide()
      },
      submit () {
        this.$refs.p.hide()
        this.$store.commit('dashboardState', { key: 'taskDetail', val: {} })
        $router.push('/dashboard')
      }
    }
  }
</script>
